<!--suppress HtmlUnknownTag -->
<template>
    <div>

        <h3 class="text-center mb-4"><strong>Job Menu</strong></h3>

        <div class="row">

            <!-- Actions -->
            <div class="col-lg-2">

                <ul class="list-group">
                    <button type="button" class="list-group-item list-group-item-secondary">Job Actions</button>
                    <button type="button" class="list-group-item list-group-item-action" @click="showNewJobModal" data-toggle="tooltip" data-placement="right" title="Open the New Job form">New Job</button>
                    <button type="button" class="list-group-item list-group-item-action" @click="toggleEditMode" data-toggle="tooltip" data-placement="right" title="Toggle Edit Mode">
                        {{edit_selected_text}}
                        <font-awesome-icon v-if="editMode" icon="toggle-on" class="float-right fa-lg"/>
                        <font-awesome-icon v-else icon="toggle-off" class="float-right fa-lg"/>
                    </button>
                    <hr>
                    <button type="button" class="list-group-item list-group-item-secondary">Reports</button>
                    <a type="button" class="list-group-item list-group-item-action" data-toggle="tooltip" data-placement="right" title="View Job Added Material">Added Material</a>
                    <a type="button" class="list-group-item list-group-item-action" data-toggle="tooltip" data-placement="right" title="View Job Transmittals">Transmittals</a>
                    <a type="button" class="list-group-item list-group-item-action" data-toggle="tooltip" data-placement="right" title="View Job Task Hours">Task Hours</a>
                    <a type="button" class="list-group-item list-group-item-action d-flex justify-content-between align-items-center" data-toggle="tooltip" data-placement="right" title="View Job RFIs">RFIs<span class="badge badge-primary badge-pill">12</span></a>
                    <a type="button" class="list-group-item list-group-item-action d-flex justify-content-between align-items-center" data-toggle="tooltip" data-placement="right" title="View Job RFIs">Unresolved RFIs<span class="badge badge-danger badge-pill">3</span></a>
                </ul>

            </div>

            <!-- Project Journal -->
            <div class="col-lg-7">
                <transition name="job" mode="out-in">
                    <div :key="job_detail.number">
                        <JobDetail v-if="!editMode" :job="job_detail"/>
                        <EditJob v-else :job="job_detail" @toggleEdit="toggleEditMode" @job_edit_submitted="editJobSubmitted"/>
                        <ProjectJournalTable v-if="!editMode" :job_num="job_detail.number"/>
                    </div>
                </transition>
            </div>

            <!-- Job list -->
            <div class="col-lg-3">
                <div class="card">

                    <h4 class="card-header text-center">

                        Active Jobs
                        <div @click="getJobList" class="float-left" data-toggle="tooltip" title="Refresh Job List">
                            <font-awesome-icon :class="{'fa-spin': syncingJobList}" icon="sync"/>
                        </div>

                    </h4>

                    <ul class="list-group list-group-flush list-scroll">
                        <li  v-for="(job, index) in activeJobs" :key="job.number"
                             class="list-group-item list-group-item-action" :class="{'active': index === active_item}"
                             @click="select_job(job, index)">
                            {{job.number}}: {{job.title}}
                        </li>
                    </ul>

                </div>
            </div>

        </div>

        <div id="NewJobForm" class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="New Job Form" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">

                    <div class="modal-header">
                        <h5 class="modal-title">New Job</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <NewJob @closeModal="hideNewJobModal" @jobSubmitted="getJobList"/>
                    </div>

                </div>
            </div>
        </div>



    </div>
</template>

<script>
    import JobDetail from "@/components/warboard/Jobs/JobDetail";
    import ProjectJournalTable from "@/components/warboard/ProjectJournal/ProjectJournalTable";
    import NewJob from "@/components/warboard/Jobs/NewJob";
    import EditJob from "@/components/warboard/Jobs/EditJob";

    import $ from 'jquery';


    export default {
        name: "JobHome",
        components: {JobDetail, ProjectJournalTable, NewJob, EditJob},
        data() {
            return {
                active_item: 0,
                job_detail: {},
                syncingJobList: false,
                editMode: false,
            }
        },
        computed: {
            activeJobs() {
                const jobs = this.$store.getters.job_list;
                return jobs.filter(function (job) {
                    return job.active
                })
            },
            edit_selected_text() {
                if(!this.editMode){
                    return 'Edit Selected'
                } else {
                    return 'Stop Editing'
                }
            },
        },
        methods: {
            select_job(job, index) {
                if(!this.editMode) {
                    this.active_item = index;
                    this.job_detail = job
                } else {
                    alert("Can't switch jobs in Edit Mode. Save or cancel first")
                }

            },
            showNewJobModal() {
                $('#NewJobForm').modal('show');
            },
            hideNewJobModal() {
                $('#NewJobForm').modal('hide');
            },
            getJobList() {

                this.syncingJobList = true;

                let payload = { action: 'obtainJobList', data: null };

                this.$store.dispatch('tryRefresh', payload).then(() => {
                    this.select_job(this.activeJobs[0], 0);
                    this.syncingJobList = false;
                }).catch(e => {
                    this.syncingJobList = false;
                    // eslint-disable-next-line no-console
                    console.log(e)
                });

            },
            __beforeMount() {

                if(this.$store.getters.job_list.length === 0) {

                    this.getJobList()

                } else {
                    this.select_job(this.activeJobs[0], 0)
                }
            },
            toggleEditMode() {
                this.editMode = !this.editMode
            },
            editJobSubmitted() {
                this.toggleEditMode();
                this.getJobList();
            },
        },
        beforeMount() {
            this.__beforeMount();
        },
        mounted() {
            $(function () {
                $('[data-toggle="tooltip"]').tooltip()
            });
        },
        component: JobDetail
    }
</script>

<!--suppress CssUnusedSymbol -->
<style scoped>

    .job-enter {
        opacity: 0;
    }

    .job-enter-active {
        transition: opacity .2s linear;
    }

    .job-leave-active, .job-leave-to {
        transition: opacity .2s linear;
        opacity: 0;
    }

    /*
    .job-leave-active, .job-leave-to {
        transition: transform .4s ease-in, opacity .4s linear;
        transform: translateY(50vh);
        opacity: 0;
    }

     */

</style>